import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Environment variables are configured

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBizSdDxw2nBqaPD7nLr_YTvT93mNCfXHc",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "cmi-mern.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "cmi-mern",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "cmi-mern.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "233713328038",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:233713328038:web:bd2caaf8176491bf7cb967",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-T7ZZWVPCWS",
};



// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Firebase initialized successfully

export default app;
